import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, Renderer2, ViewChildren } from '@angular/core';
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginPasswordService } from '../../../services/login-password.service';
import { LoginPasswordDTO, MfaCodeModel, RefreshTokenDTO } from '../../../models/login';
import { AuthJwtService } from '../../../services/auth-jwt.service';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';
import { TrackingService } from '../../../services/tracking.service';
import { LogType } from '../../../enums/logtype';

@Component({
  templateUrl: './2FAForm.component.html',
  styleUrls: ['./2FAForm.component.scss'],
  selector: 'app-2FaForm',
})
export class TWOFAFormComponent implements OnInit {

  @ViewChildren('codeInput') codeInputs!: QueryList<ElementRef>;
  // @ViewChildren('codeInput') codeInputs: QueryList<ElementRef>;
  loginform: FormGroup;
  codeControls = ['digit1', 'digit2', 'digit3', 'digit4', 'digit5', 'digit6'];
  submitted = 0;
  @Output() apiResponse = new EventEmitter<LoginPasswordDTO>();
  @Output() loginApiResponse = new EventEmitter<RefreshTokenDTO>();
  isDisabled = false;
  isLogin = true;
  logError = false;
  emailUser: string;
  @Input() IdUser: string;

  constructor(
    private loginSevice: LoginPasswordService, private fb: FormBuilder, private authService: AuthJwtService, private userService: UserService,
    private router: Router, private trackingService: TrackingService
  ) {
    this.loginform = this.fb.group({
      digit1: ['', [Validators.required, Validators.pattern('[0-9]')]],
      digit2: ['', [Validators.required, Validators.pattern('[0-9]')]],
      digit3: ['', [Validators.required, Validators.pattern('[0-9]')]],
      digit4: ['', [Validators.required, Validators.pattern('[0-9]')]],
      digit5: ['', [Validators.required, Validators.pattern('[0-9]')]],
      digit6: ['', [Validators.required, Validators.pattern('[0-9]')]]
    });
  }

  ngOnInit(): void {

  }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();

    // Solo permitir números
    if (/^\d$/.test(value)) { 
      input.value = value; // Sobreescribe el número anterior automáticamente

      // Si no es el último campo, mover el foco automáticamente al siguiente input
      if (index < this.codeInputs.length - 1) {
        const nextInput = this.codeInputs.toArray()[index + 1].nativeElement;
        nextInput.focus();
      } else {
        // Cuando se complete el último campo, eliminamos el foco
        input.blur();
      }
    } else {
      input.value = ""; // Si no es un número válido, borra el contenido
    }
  }

  onKeyDown(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;

    // Permitir solo números y teclas de control (Backspace, Tab, etc.)
    if (!/[0-9]/.test(event.key) && !["Backspace", "Tab"].includes(event.key)) {
      event.preventDefault();
    }

    // Si presiona Backspace y el campo está vacío, mueve el foco al input anterior
    if (event.key === "Backspace" && index > 0 && input.value === "") {
      const prevInput = this.codeInputs.toArray()[index - 1].nativeElement;
      prevInput.focus();
    }
  }

  onFocus(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    input.select(); // Selecciona el contenido actual
  }


  // onInput(event: Event, index: number): void {
  //   const input = event.target as HTMLInputElement;
  //   const value = input.value.trim();

  //   if (value.length === 1 && index < this.codeControls.length - 1) {
  //     const nextInput = this.codeInputs.toArray()[index + 1].nativeElement;
  //     if (nextInput) {
  //       nextInput.focus();
  //     }
  //   }
  // }

  // onKeyDown(event: KeyboardEvent, index: number): void {
  //   const input = event.target as HTMLInputElement;
  //   if (event.key === 'Backspace' && input.value.length === 0 && index > 0) {
  //     const prevInput = this.codeInputs.toArray()[index - 1].nativeElement;
  //     if (prevInput) {
  //       prevInput.focus();
  //     }
  //   }
  // }


  send() {

    this.submitted = 1;

    if (this.loginform.invalid) return;

    const code = this.codeControls.map(control => this.loginform.get(control).value).join('');

    if (this.isLogin) {

      this.logError = false;

      this.loginSevice.TotpPassword(new MfaCodeModel({ code: code, email: this.emailUser })).subscribe(res => {

        if (res.PassRetry) {
          this.loginApiResponse.emit(res);
          return;
        }

        if (res.Token && res.Token.length > 0) {
          this.authService.setStorageToken(res.Token);
          this.authService.setStorageRefreshToken(res.RefreshToken);
          this.userService.initializeUserData();
          this.router.navigateByUrl('/home');
          this.trackUser(LogType.Login);
        } else {
          this.logError = true;
        }

      }, (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al crear'
        });
      });


    } else {

      this.loginSevice.EnabledTwoFactorCode(new MfaCodeModel({ code: code, idUser: this.IdUser },)).subscribe(res => {

        this.apiResponse.emit(res);

        if (res.RegistrationToken == null) {
          Swal.fire({
            icon: 'error',
            title: 'el código proporcionado no es correcto'
          });
        }

      }, (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al crear'
        });
      });
    }

  }

  trackUser(idLogType: number) {
    this.trackingService.trackUser({ IdLogType: idLogType, Url: this.router.url }).subscribe();
  }
}
